import { useState } from "react";
import { groupApi } from "../api/group.service";
import { ActionSingleAttendantPayload } from "../types";

export const useActionSingleAttendant = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (
    group_id: string,
    payload: ActionSingleAttendantPayload
  ) => {
    try {
      setLoading(true);

      const response: any = await groupApi.actionSingleMember(
        group_id,
        payload
      );

      return {
        success: true,
        message: response?.data?.message,
      };
    } catch (err: any) {
      console.log("Action single attendant failed:", err);

      return {
        success: false,
        message: err?.response?.data?.message || "Something wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
